import React from "react";
import { procMe, procWho } from "../Procedures/procPeople";
import { procText, procNorm } from "../Procedures/procHelpers";

// Utilitaires de la Base de connaissance (reprise de kb.jsx du prototype).

export const KB_DOMAINS = [
  { id: "fiscal", name: "Fiscal", color: "#6E1A36" },
  { id: "social", name: "Social", color: "#1F4E79" },
  { id: "juri", name: "Juridique", color: "#0E5C3A" },
  { id: "compta", name: "Comptable", color: "#8B6A0F" },
  { id: "gestion", name: "Gestion & conseil", color: "#4D3F45" },
];

export const KB_ACCEPT = { "application/pdf": "pdf", "image/jpeg": "jpg", "image/png": "png" };
export const KB_STATUS = {
  encours: { lab: "En cours", tone: "warn" },
  conclu: { lab: "Conclu", tone: "ok" },
};

// Valider un dossier est réservé aux experts-comptables ; les administrateurs
// le peuvent aussi (choix du 07/10/2026) pour pouvoir essayer la validation.
export const kbIsEC = (id = procMe()) => ["EXPERT_COMPTABLE", "ADMINISTRATEUR"].includes(procWho(id).role);

export const kbIsUrl = (u) => /^https?:\/\/[^\s.]+\.[^\s]+$/i.test(u.trim());
export const kbDom = (id) => KB_DOMAINS.find((d) => d.id === id) || KB_DOMAINS[0];

// nomClient : résout l'identifiant d'un client lié en son nom (liste en cache).
export const kbFolderText = (f, nomClient = () => "") =>
  [
    f.title,
    f.tags.join(" "),
    (f.clients || []).map((id) => nomClient(id)).join(" "),
    procText(f.synthese || ""),
    ...f.items.map((it) => [it.title, it.url, it.name].filter(Boolean).join(" ")),
  ].join(" \n ");

export const kbFmtSize = (n) =>
  n > 1048576 ? (n / 1048576).toFixed(1) + " Mo" : Math.max(1, Math.round(n / 1024)) + " Ko";

// Extrait autour de la première occurrence de la recherche, mot surligné.
export const kbSnip = (text, q) => {
  const n = procNorm(text);
  const i = n.indexOf(procNorm(q));
  if (i < 0) return null;
  const s = Math.max(0, i - 50);
  const e = Math.min(text.length, i + q.length + 70);
  return (
    <>
      {s > 0 && "…"}
      {text.slice(s, i)}
      <mark>{text.slice(i, i + q.length)}</mark>
      {text.slice(i + q.length, e)}
      {e < text.length && "…"}
    </>
  );
};

export const kbHi = (t, q) => {
  if (!q) return t;
  const i = procNorm(t).indexOf(procNorm(q));
  if (i < 0) return t;
  return (
    <>
      {t.slice(0, i)}
      <mark>{t.slice(i, i + q.length)}</mark>
      {t.slice(i + q.length)}
    </>
  );
};
